import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>SAT Prep &mdash; practice questions, flashcards, and timed exams.</p>
      <p className="footer-disclaimer">
        Practice questions and answer explanations are AI-generated original content written in the style of the
        digital SAT. They are not actual questions from any College Board exam &mdash; the College Board
        copyrights its exam questions and prohibits their reproduction, so nothing here is drawn from a real exam.
      </p>
    </footer>
  );
}
